export default __webpack_public_path__ + "static/granola-3ac41c3aff0f80fb0149375f56e88645.webp";